import Vue from 'vue'
import Router from 'vue-router'
import ROUTES from 'Routes'
import {ROUTER_DEFAULT_CONFIG} from 'Config/index'
import {routerBeforeEachFunc} from 'Config/interceptors/router'
import api from 'Plugins/api'
import {getSysParameterallow} from 'Utils/publicApi'
import store from './store'

Vue.use(Router)
// 解决 NavigationDuplicated: Avoided redundant navigation to current location 报错
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 注入默认配置和路由表
let routerInstance = new Router({
  ...ROUTER_DEFAULT_CONFIG,
  routes: ROUTES
})
console.log(routerInstance.options.routes)
/**
 * 动态加载路由
 * 现阶段主要服务于 home页面
 * @param parentName : string 父路由的name
 * @param route : RouteConfig 路由配置
 */
var homepage = {
  'QHHK': {home: 'qhhk/home', dashboard: 'qhhk/dashboard', compName: '智通天行', service: 'btlh/service'},
  'KHSL': {home: 'cckh/home', dashboard: 'cckh/dashboard', compName: '长春凯航', service: 'btlh/service'},
  'BTLH': {
    home: 'btlh/home',
    message: 'btlh/message',
    service: 'btlh/service',
    dashboard: 'btlh/dashboard',
    compName: '柒个贰包头联航'
  },
  'DEFAULT': {
    home: 'default/home',
    dashboard: 'default/dashboard',
    service: 'btlh/service',
    compName: '智通商旅',
    login: 'default/User/Login'
  },
  'YXSL': {home: 'yxsl/home', dashboard: 'yxsl/dashboard', service: 'btlh/service', compName: '智通商旅'},
  'BJZXYX': {home: 'bjzxyx/home', dashboard: 'bjzxyx/dashboard', service: 'btlh/service', compName: '北京尊享悦行'},
  'Comfort': {
    home: 'default/homenew',
    dashboard: 'default/dashboardnew',
    service: 'btlh/service',
    compName: '康辉H5',
    login: 'kh/User/Login'
  },
}
var compNo = '' // process.env.VUE_APP_homeStyle

const pageSet = async () => {
  try {
    let {data = {}} = await api['common/etPageSetList']()
    if(data.by4) { //home 页面标志
      compNo = data.by4
    }
  } catch(err) {
    throw (err)
  } finally {
    var address = homepage[compNo] || homepage['DEFAULT']
    if(store.getters.loginConfig.compaySuper) {//判断新旧页面
      let Pagenew = await getSysParameterallow('11605067', store.getters.loginConfig.compaySuper)
      if(Pagenew.value1 == 1) {
        address.home = 'default/homenew'
        address.dashboard = 'default/dashboardnew'
        store.commit('app/newpage', true)
      }
      localStorage.setItem('Pagenew', Pagenew.value1); //存到本地存储
    }
    routerInstance.addRoutes([
      {
        name: 'login',
        path: '/login',
        component: (resolve) => require([`Components/Dynamic/${address.login}`], resolve),
        meta: {
          include: ['Dashboard'],
          index: 0
        }
      },
      {
        name: 'dashboard',
        path: '/dashboard',
        component: (resolve) => require([`Components/Dynamic/${address.dashboard}`], resolve),
        meta: {
          include: ['Dashboard'],
          index: 0
        },
        children: [
          // 康辉登录
          {
            name: 'login',
            path: '/login',
            component: (resolve) => require([`Components/Dynamic/${address.login}`], resolve),
            meta: {
              include: ['Home', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'home',
            path: '/home',
            component: (resolve) => require([`Components/Dynamic/${address.home}`], resolve),
            meta: {
              include: ['Home', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0

            }
          },
          {
            name: 'allorder',
            path: '/allorder',
            component: (resolve) => require(['Views/Home/allorder'], resolve),
            meta: {
              include: ['Home', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'tripList',
            path: '/tripList',
            component: (resolve) => require(['Views/Home/tripList'], resolve),
            meta: {
              include: ['Home', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'khList',
            path: '/khList',
            component: (resolve) => require(['Components/Dynamic/kh/views/tripList/index.vue'], resolve),
            meta: {
              include: ['Home', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'approvalList',
            path: '/approvalList',
            component: (resolve) => require(['Views/Home/approvalList'], resolve),
            meta: {
              include: ['Home', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'userCenter',
            path: '/userCenter',
            component: (resolve) => require(['Views/Home/userCenter'], resolve),
            meta: {
              include: ['Home', 'Allorder', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          // 康辉
          {
            name: 'khuserCenter',
            path: '/khuserCenter',
            component: (resolve) => require(['Components/Dynamic/kh/userCenter/index'], resolve),
            meta: {
              include: ['Home', 'Allorder', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'message',
            path: '/message',
            component: (resolve) => require([`Components/Dynamic/${address.message}`], resolve),
            meta: {
              include: ['Home', 'service', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'noticeList',
            path: '/noticeList',
            component: (resolve) => require(['Views/Home/userCenter/Notice'], resolve),
            meta: {
              include: ['Home', 'message', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'service',
            path: '/service',
            component: (resolve) => require([`Components/Dynamic/${address.service}`], resolve),
            meta: {
              include: ['Home', 'message', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'allMessage',
            path: '/userCenter/message',
            component: (resolve) => require(['Views/Home/userCenter/Message/index.vue'], resolve),
            meta: {
              include: ['Home', 'message', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'schedule',
            path: '/schedule',
            component: (resolve) => require(['Views/Home/schedule'], resolve),
            meta: {
              include: ['Home', 'message', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'statistical',
            path: '/statistical',
            component: (resolve) => require(['Views/Home/statistical'], resolve),
            meta: {
              include: ['Home', 'message', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
          {
            name: 'tkQueryInx',
            path: '/tk/tkQuery',
            component: (resolve) => require(['Views/Tk/tkQuery'], resolve),
            meta: {
              include: ['Home', 'message', 'ApprovalList', 'UserCenter', 'service', 'allMessage'],
              index: 0
            }
          },
        ]
      }])

    // 注入拦截器
    routerInstance.beforeEach(routerBeforeEachFunc)
  }

}
pageSet()

// routerInstance.beforeEach(routerBeforeEachFunc)

export default routerInstance
